// extracted by mini-css-extract-plugin
export default {"logo":"siderMenu_logo__DpuiY"};